import { render, staticRenderFns } from "./TicketEscalationReview.vue?vue&type=template&id=fa4947da&"
import script from "./TicketEscalationReview.vue?vue&type=script&lang=ts&"
export * from "./TicketEscalationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports